import { MutableRefObject } from 'react';

import { VideoPlayer } from '@/components/Video/VideoPlayer';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

export function BroadcastScheduleProgramGlobalViewBodyVideoPlayer() {
  const {
    activeClip,
    visibleBox,
    presenceData,
    pendingSeekTime,
    videoControlRef,
    setPlayerVideoCurrentTime,
    setPlayerVideoDuration,
    setPlayerVideoIsPlaying,
    setPendingSeekTime,
  } = useBroadcastScheduleProgram();

  return (
    <VideoPlayer
      url={activeClip?.presigned_url || ''}
      controls={false}
      customControls
      activeBox={visibleBox}
      presenceData={presenceData}
      pendingSeekTime={pendingSeekTime}
      setPendingSeekTime={setPendingSeekTime}
      setPlayerVideoCurrentTime={setPlayerVideoCurrentTime}
      setPlayerVideoDuration={setPlayerVideoDuration}
      setPlayerVideoIsPlaying={setPlayerVideoIsPlaying}
      onRefReady={ref => {
        if (videoControlRef && 'current' in videoControlRef) {
          (videoControlRef as MutableRefObject<unknown>).current = ref;
        }
      }}
    />
  );
}
